import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { DateBox } from "devextreme-react/date-box";
import { RadioGroup } from "devextreme-react/radio-group";
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { confirm } from "devextreme/ui/dialog";
import { SelectBox } from "devextreme-react/select-box";
import { Popup } from "devextreme-react/popup";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { GetDatePartOnlyDiffFormat } from "../../../common/Utils.js";
import { GridLayout } from "../../../common/GridLayout";
import { handleDataGridExport } from "../../../common/Utils";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";

import DataGrid, {
  Column,
  Editing,
  Paging,
  Pager,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  HeaderFilter,
  StateStoring
} from "devextreme-react/data-grid";

import { createStore } from "devextreme-aspnet-data-nojquery";

const filterBuilderPopupPosition = {
  of: window,
  at: "top",
  my: "top",
  offset: { y: 10 },
};

const processCodes = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];

const dataGrid = React.createRef();
let accessToken = "";
function renderShipCompleteHeaderLabel() {
  return (
    <p className="main-title" style={{ marginTop: "18px" }}>
      Ship Complete
    </p>
  );
}

const reports = [
  { id: 1, text: "Nursery Report" },
  { id: 2, text: "Greenhouse Report" },
];

const gridKey = "10567bbd-39ea-49eb-bed7-8e7abbfcc6c1";

class ShipComplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedReport: 0,
      completeDate: new Date(),
      processCode: "A",
      popupVisible: false,
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false,
      connection: null,
      generatedReportFileName: "",
      cutLot: {
        rowid: "00000000-0000-0000-0000-000000000000",
        newwetweight: 0.0,
        lotcutdate: new Date(),
        newbags: 0,
        newseedslb: 0,
        fieldname: "",

      },
      currentLayout: "Default",
    };

    accessToken = props.oidc.user.access_token;
    this.onContentReady = this.onContentReady.bind(this);
    this.onReportChange = this.onReportChange.bind(this);
    this.setIsShippedValue = this.setIsShippedValue.bind(this);
    this.onCompleteDateChanged = this.onCompleteDateChanged.bind(this);
    this.processButtonClicked = this.processButtonClicked.bind(this);
    this.handleProcessCodeChange = this.handleProcessCodeChange.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.popupOKClick = this.popupOKClick.bind(this);
    this.formFieldChanged = this.formFieldChanged.bind(this);

    this.dataSource = createStore({
      key: "rowid",
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.shipcomplete.AllShipCompletes}`,
      updateUrl: `${window._env_.REACT_APP_APIS}/${routes.shipcomplete.UpdateShipComplete}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      },
    });

    const newConnection = new HubConnectionBuilder()
      .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
      .withAutomaticReconnect()
      .build();

    this.state.connection = newConnection;

    if (this.state.connection) {

      this.state.connection
        .start()
        .then((result) => {
          console.log("Connected!");

          this.state.connection.on("ReceiveMessage", (message) => {

            this.setState({
              generatedFileName: message.message,
              isGetReportPopupVisible: true,
              isReportInProgressPopupVisible: false
            });
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }
  setCurrentLayout = (value) => {
    this.setState({
      currentLayout: value
    })
  }
  loadState = () => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, this.state.currentLayout); }
  saveState = (state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout); }
  download = () => {

    var url = `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${this.state.generatedFileName}`;

    const link = document.createElement("a");
    link.href = url;
    link.download = this.state.generatedFileName;
    link.click();
  }

  renderPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={this.closeGetReportPopup} className="report-btn">
          Close
        </Button>
        <Button onClick={this.download} className="report-btn ml-3">
          Download Report
        </Button>
      </div>
    )
  }

  renderReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report generation is in progess ...</p>
        <Button onClick={this.closeReportInProgressPopup} className="report-btn">
          Close
        </Button>
      </div>
    )
  }

  closeGetReportPopup = () => {

    this.setState({
      isGetReportPopupVisible: false,
      isReportInProgressPopupVisible: false
    });
  }

  closeReportInProgressPopup = () => {

    this.setState({
      isReportInProgressPopupVisible: false
    });
  }

  render() {
    return (
      <div className="h-100" style={{ overflowY: 'hidden' }}>
        {/* Title and toolbar container */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            backgroundColor: 'rgb(240, 241, 239)',
            padding: '10px',
            gap: '20px',
            flexWrap: 'wrap',
          }}
        >
          {/* Left: Title */}
          <h6
            style={{
              color: window._env_.Color2,
              margin: 0,
            }}
          >
            Ship Complete
          </h6>

          {/* Right: Controls */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <DateBox
              type="date"
              placeholder="Date"
              value={this.state.completeDate}
              onValueChanged={this.onCompleteDateChanged}
            />

            <SelectBox
              placeholder="Process Code"
              items={processCodes}
              defaultValue={processCodes[0]}
              onValueChanged={this.handleProcessCodeChange}
            />

            <RadioGroup
              items={reports}
              value={this.state.selectedReport}
              valueExpr="id"
              displayExpr="text"
              layout="horizontal"
              onValueChanged={this.onReportChange}
            />
            <Button
              text="Process Order"
              type="default"
              onClick={this.processButtonClicked}
            />
          </div>
        </div>
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
          id="gridContainer"
          onContentReady={this.onContentReady}
          onCellPrepared={this.onCellPrepared}
          ref={dataGrid}
          showBorders={true}
          className="SO_StartCompleteGridStyle"
          rowAlternationEnabled={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Paging enabled={false} />
          <Pager
            visible={true}
            showPageSizeSelector={false}
            showNavigationButtons={false}
            showInfo={true}
            infoText="({2} items)"
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true} />,
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Sorting mode="multiple" />
          <Editing
            mode="cell"
            refreshMode="reshape"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false}
          />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column
            dataField="isshipped"
            dataType="boolean"
            caption=""
            setCellValue={this.setIsShippedValue}
          />
          <Column
            dataField="shippeddate"
            dataType="date"
            caption="Ship Complete"
            allowEditing={false}
          />
          <Column
            dataField="species"
            caption="Species"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="prodlot"
            caption="Production Lot"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="celltype"
            caption="Stock"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="facility"
            caption="Facility"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="color"
            caption="Color"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="symbol"
            caption="Symbol"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="finalbags"
            caption="Bags"
            dataType="number"
            allowEditing={false}
            cssClass="column-readonly"
          />
          <Column
            dataField="shippedcode"
            className="shipped-code"
            caption=""
            allowEditing={false}
          />
          <Toolbar>
            <Item location="after">
              <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
        <Popup
          visible={this.state.popupVisible}
          onHiding={this.hidePopup}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title="Prod Lot"
          container=".dx-viewport"
          closeOnOutsideClick={true}
          width={500}
          height={400}
        >
          <Form
            id="cutLotForm"
            labelMode="static"
            labelLocation="left"
            formData={this.state.cutLot}
            minColWidth={100}
            colCount={1}
            onFieldDataChanged={this.formFieldChanged}
          >
            <SimpleItem dataField="newwetweight">
              <Label text="New Net Weight"></Label>
            </SimpleItem>
            <SimpleItem dataField="lotcutdate">
              <Label text="Lot Cut Date"></Label>
            </SimpleItem>
            <SimpleItem dataField="newbags">
              <Label text="New Bags"></Label>
            </SimpleItem>
            <SimpleItem dataField="newseedslb">
              <Label text="New Seeds LB"></Label>
            </SimpleItem>
          </Form>
          <div>
            <Button
              text="OK"
              type="default"
              onClick={this.popupOKClick}
            ></Button>
          </div>
        </Popup>
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isGetReportPopupVisible}
          contentRender={this.renderPopup}
        />
        <Popup
          width={450}
          height={160}
          showTitle={false}
          title="Generate Report!"
          dragEnabled={false}
          hideOnOutsideClick={true}
          visible={this.state.isReportInProgressPopupVisible}
          contentRender={this.renderReportInProgressPopup}
        />
      </div>
    );
  }

  formFieldChanged(e) {
    var that = this;
    this.state.cutLot.fieldname = e.dataField;
    axios
      .put(
        `${window._env_.REACT_APP_APIS}/${routes.shipcomplete.InsertUpdateCutLot}`,
        this.state.cutLot,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        let rows = dataGrid.current.instance().getVisibleRows();
        let rowIndex = dataGrid.current.instance().getRowIndexByKey(
          that.state.cutLot.rowid
        );
        let row = rows[rowIndex];
        switch (e.dataField) {
          case "newwetweight":
            row.data.newwetweight = that.state.cutLot.newwetweight;
            break;
          case "lotcutdate":
            row.data.lotcutdate = that.state.cutLot.lotcutdate;
            break;
          case "newbags":
            row.data.newbags = that.state.cutLot.newbags;
            break;
          case "newseedslb":
            row.data.newseedslb = that.state.cutLot.newseedslb;
            break;
        }
      })
      .catch((err) => {
        alert(err, "Error");
      });
  }

  popupOKClick() {
    this.hidePopup();
  }

  hidePopup() {
    this.setState({
      popupVisible: false,
    });
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

  onCellPrepared = (e) => {
    if (e.rowType === "data" && e.column.dataField === "shippedcode") {
      e.cellElement.style.color = "#FF0000";
    }
  };

  handleProcessCodeChange(e) {
    this.setState({
      processCode: e.value,
    });
  }

  onCompleteDateChanged(e) {
    this.setState({
      completeDate: e.value,
    });
  }

  onReportChange(e) {
    this.setState({
      selectedReport: e.value,
    });
  }

  setIsShippedValue(newData, value, currentRowData) {
    if (
      (currentRowData.iscut === true &&
        (currentRowData.newwetweight === null ||
          currentRowData.newbags === null ||
          currentRowData.newseedslb === null)) ||
      currentRowData.newwetweight === 0 ||
      currentRowData.newbags === 0 ||
      currentRowData.newseedslb === 0
    ) {
      var cutLot = { ...this.state.cutLot };
      cutLot.rowid = currentRowData.rowid;
      cutLot.lotcutdate = currentRowData.lotcutdate;
      cutLot.newwetweight = currentRowData.newwetweight;
      cutLot.newbags = currentRowData.newbags;
      cutLot.newseedslb = currentRowData.newseedslb;
      this.setState({ cutLot });
      this.setState({
        popupVisible: true,
      });
    } else {
      var rowIndex = dataGrid.current.instance().getRowIndexByKey(
        currentRowData.rowid
      );

      if (value) {
        dataGrid.current.instance().cellValue(
          rowIndex,
          "shippeddate",
          this.state.completeDate
        );
        dataGrid.current.instance().cellValue(
          rowIndex,
          "shippedcode",
          this.state.processCode
        );
      } else {
        dataGrid.current.instance().cellValue(rowIndex, "shippeddate", "");
        dataGrid.current.instance().cellValue(rowIndex, "shippedcode", "");
      }

      dataGrid.current.instance().saveEditData();
    }
  }

  processButtonClicked() {
    let result = confirm("<i>Process Ship Completion?</i>", "Process Order");
    var that = this;
    result.then((dialogResult) => {
      if (dialogResult) {
        dataGrid.current.instance().beginCustomLoading("Processing");
        axios
          .put(
            `${window._env_.REACT_APP_APIS}/${routes.shipcomplete.ProcessOrders}`,
            null,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();

            if (that.state.selectedReport != 0) {

              var report = new Object();
              report.Name = that.state.selectedReport == 1 ? "SOR0013" : "SOR0012";
              report.IgnoreFormat = true;
              var whereInfo = new Object();
              whereInfo.FieldType = 4; //ParameterTypeEnum.DateTime;
              whereInfo.FieldName = "ShippedDate";
              whereInfo.Operation = 3; //OperationEnum.Equal
              whereInfo.Origin = "SOMASTERDATABASE.SHIPPEDDATE";
              whereInfo.From = GetDatePartOnlyDiffFormat(that.state.completeDate, "/");
              report.FilterWhereInfoList = [];
              report.FilterWhereInfoList.push(whereInfo);

              axios.post
                (
                  `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
                  report,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      access_token: accessToken,
                    },
                  }
                )
                .then((res) => {
                  if (window._env_.Generate_Report_From_Remote) {
                    if (res.data.isSuccess) {
                      that.setState({
                        isGetReportPopupVisible: false,
                        isReportInProgressPopupVisible: true
                      });
                    }
                    else {
                      alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                    }

                  }
                  else {
                    if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
                      if (res.data.isSuccess) {
                        window.open(`${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`, '_blank');
                      }
                      else {
                        alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                      }

                    }
                    else {
                      alert("Cannot generate report", "Error");
                    }
                  }

                })
                .catch((err) => {

                  alert(err, "Error");
                });
            }

            dataGrid.current.instance().refresh();

          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });
      }
    });
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ShipComplete);
